import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "i18n/locale/en.json";
import deTranslation from "i18n/locale/de.json";
import zhTranslation from "i18n/locale/zh.json";
import chtTranslation from "i18n/locale/cht.json";
import jpTranslation from "i18n/locale/jp.json";

i18next.use(initReactI18next).init({
  lng: "zh", // 默认语言
  fallbackLng: "zh", // 如果找不到翻译，将回退到的语言
  debug: true,
  resources: {
    en: {
      translation: enTranslation,
    },
    de: {
      translation: deTranslation,
    },
    zh: {
      translation: zhTranslation,
    },
    cht: {
      translation: chtTranslation,
    },
    jp: {
      translation: jpTranslation,
    },
  },
  interpolation: {
    escapeValue: false, // 允许在翻译中使用变量
  },
});

export default i18next;
